import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../api.js';

const URL = `${process.env.REACT_APP_API_URL}/api/utentiDemo2`;


export const fetchUsersData = createAsyncThunk(
  'usersData/fetchUsersData',
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get(URL);
      return Array.isArray(res.data) ? res.data : [];
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Error loading users data');
    }
  }
);


export const addUserData = createAsyncThunk(
  'usersData/addUserData',
  async (userData, { rejectWithValue }) => {
    try {
      const res = await api.post(URL, userData);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Error adding user data');
    }
  }
);


export const editUserData = createAsyncThunk(
  'usersData/editUserData',
  async (userData, { rejectWithValue }) => {
    try {
      const res = await api.put(`${URL}/${userData.id}`, userData);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Error updating user data');
    }
  }
);


export const deleteUserData = createAsyncThunk(
  'usersData/deleteUserData',
  async (id, { rejectWithValue }) => {
    try {
      await api.delete(`${URL}/${id}`);
      return id;
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Error deleting user data');
    }
  }
);

const usersDataSlice = createSlice({
  name: 'usersData',
  initialState: {
    list: [],
    currentPage: 1,
    isLoading: false,
    error: null,
  },
  reducers: {
    setCurrentPage(state, action) {
      state.currentPage = action.payload;
    },
    clearError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsersData.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchUsersData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload;
      })
      .addCase(fetchUsersData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || 'Error loading users data';
      })


      .addCase(addUserData.fulfilled, (state, action) => {
        if (action.payload) state.list.push(action.payload);
      })
      .addCase(addUserData.rejected, (state, action) => {
        state.error = action.payload;
      })


      .addCase(editUserData.fulfilled, (state, action) => {
        const index = state.list.findIndex((u) => u.id === action.payload.id);
        if (index !== -1) state.list[index] = action.payload;
      })
      .addCase(editUserData.rejected, (state, action) => {
        state.error = action.payload;
      })


      .addCase(deleteUserData.fulfilled, (state, action) => {
        state.list = state.list.filter((u) => u.id !== action.payload);
      })
      .addCase(deleteUserData.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export const { setCurrentPage, clearError } = usersDataSlice.actions;
export default usersDataSlice.reducer;
